export default __webpack_public_path__ + "static/media/timeline.622fad36.svg";